import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { filesStorageApi } from "redux/modules/common/filesStorage/filesStorageApi";
import { createFileInStorage } from "redux/modules/common/filesStorage/thunks";

import { IRouterParamsWithObjectId } from "types/routerTypes";

import styles from "./FileUploadInStorage.module.scss";

interface IProps {
  sectionId?: number;
}

const FileUploadInStorage: React.FC<IProps> = ({ sectionId }) => {
  const dispatch = useDispatch();
  const generatedId = React.useRef(String(Math.random()));
  const { objectId } = useParams<IRouterParamsWithObjectId>();

  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files?.[0]) return;
    dispatch(createFileInStorage(e.target.files[0], objectId, sectionId));
  };

  if (!objectId || objectId === "0") return null;

  return (
    <label htmlFor={generatedId.current} className={styles.container}>
      <div className={styles.btn}>
        <svg
          width="30"
          height="23"
          viewBox="0 0 30 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.764 8.84682V8.73682C25.7647 6.99645 25.2045 5.3022 24.1664 3.90531C23.1283 2.50842 21.6677 1.48327 20.0011 0.98188C18.3346 0.480492 16.5508 0.529565 14.9143 1.12182C13.2778 1.71407 11.8757 2.81797 10.916 4.26982C10.0565 3.98299 9.14118 3.90442 8.24537 4.04057C7.34957 4.17672 6.49891 4.5237 5.76344 5.05294C5.02797 5.58218 4.42873 6.27854 4.01505 7.08469C3.60137 7.89084 3.38509 8.78372 3.38402 9.68982V9.81182C2.48371 10.0413 1.6983 10.5919 1.17562 11.36C0.652937 12.1281 0.429021 13.0608 0.546015 13.9825C0.663009 14.9042 1.11284 15.7513 1.81086 16.3645C2.50887 16.9777 3.40693 17.3146 4.33602 17.3118H12.875C13.0013 17.3118 13.1223 17.2617 13.2116 17.1724C13.3009 17.0831 13.351 16.9621 13.351 16.8358C13.351 16.7096 13.3009 16.5885 13.2116 16.4992C13.1223 16.41 13.0013 16.3598 12.875 16.3598H4.33302C3.61195 16.3556 2.91915 16.0789 2.39359 15.5852C1.86803 15.0915 1.5486 14.4173 1.49938 13.6979C1.45015 12.9785 1.67478 12.2671 2.12818 11.7064C2.58159 11.1457 3.23025 10.7772 3.94402 10.6748C4.06535 10.6586 4.17575 10.5962 4.25229 10.5007C4.32883 10.4051 4.36562 10.2838 4.35502 10.1618C4.34202 10.0088 4.33302 9.85082 4.33302 9.69282C4.33382 8.9091 4.52781 8.13766 4.8978 7.44677C5.26779 6.75588 5.80238 6.16685 6.45426 5.7318C7.10614 5.29675 7.85521 5.0291 8.63519 4.95253C9.41516 4.87596 10.202 4.99284 10.926 5.29282C11.0322 5.3365 11.1506 5.34031 11.2594 5.30356C11.3682 5.2668 11.4601 5.19196 11.518 5.09282C12.3152 3.74431 13.5337 2.69532 14.9857 2.10742C16.4378 1.51952 18.0428 1.42533 19.5536 1.83936C21.0644 2.25339 22.3972 3.15267 23.3467 4.39867C24.2962 5.64468 24.8096 7.16829 24.808 8.73482C24.808 8.89282 24.808 9.04481 24.791 9.19881C24.7803 9.32216 24.8181 9.44482 24.8963 9.54079C24.9745 9.63675 25.087 9.69846 25.21 9.71282C26.0517 9.81647 26.8221 10.237 27.3646 10.8889C27.907 11.5407 28.1806 12.3747 28.1296 13.2212C28.0786 14.0677 27.7069 14.8629 27.0902 15.4449C26.4734 16.0269 25.658 16.3519 24.81 16.3538C24.6666 16.3541 24.5234 16.3458 24.381 16.3288C24.3133 16.3207 24.2446 16.3293 24.181 16.3538H16.7C16.5738 16.3538 16.4527 16.404 16.3634 16.4932C16.2742 16.5825 16.224 16.7036 16.224 16.8298C16.224 16.9561 16.2742 17.0771 16.3634 17.1664C16.4527 17.2557 16.5738 17.3058 16.7 17.3058H24.333C24.3695 17.3057 24.4059 17.3006 24.441 17.2908C24.561 17.3008 24.685 17.3058 24.81 17.3058C25.8644 17.307 26.8821 16.9194 27.6686 16.2172C28.4551 15.515 28.9551 14.5475 29.073 13.4998C29.1908 12.452 28.9182 11.3976 28.3074 10.5382C27.6965 9.67886 26.7903 9.07488 25.762 8.84182L25.764 8.84682Z"
            fill="white"
            stroke="white"
            strokeWidth="0.5"
          />
          <path
            d="M18.519 14.0555L15.292 10.8285V21.5285C15.292 21.6547 15.2419 21.7758 15.1526 21.865C15.0633 21.9543 14.9423 22.0045 14.816 22.0045C14.6898 22.0045 14.5687 21.9543 14.4794 21.865C14.3902 21.7758 14.34 21.6547 14.34 21.5285V10.8285L11.113 14.0555C11.0231 14.1415 10.9031 14.1888 10.7787 14.1875C10.6543 14.1861 10.5354 14.136 10.4474 14.0481C10.3594 13.9601 10.3094 13.8412 10.308 13.7168C10.3066 13.5924 10.354 13.4724 10.44 13.3824L14.48 9.34245C14.5693 9.25324 14.6903 9.20312 14.8165 9.20312C14.9427 9.20312 15.0638 9.25324 15.153 9.34245L19.193 13.3824C19.279 13.4724 19.3264 13.5924 19.325 13.7168C19.3236 13.8412 19.2736 13.9601 19.1856 14.0481C19.0977 14.136 18.9787 14.1861 18.8543 14.1875C18.7299 14.1888 18.6099 14.1415 18.52 14.0555H18.519Z"
            fill="white"
            stroke="white"
            strokeWidth="0.5"
          />
        </svg>
        Загрузить
      </div>
      <input
        type="file"
        id={generatedId.current}
        className={styles.input}
        onChange={changeHandler}
      />
    </label>
  );
};

export default FileUploadInStorage;
